import React from 'react'
import { LoadingIcon } from '../icons/LoadingIcon'

export interface LoadingOverlayProps {
    /**
     * Accepted sizes: small | medium | large
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * This makes it possible to pass through additional props.
     */
    [propName: string]: any
}

export function LoadingOverlay({
    size = 'large',
    ...rest
}: LoadingOverlayProps) {
    return (
        <div
            {...rest}
            className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center text-center"
        >
            <div className={`h-full w-full bg-white opacity-50`}></div>
            <LoadingIcon className="absolute" size={size} />
        </div>
    )
}
